import { useEffect, useRef, useState } from 'react';
import useDocumentTitle from '../../../../hooks/useDocumentTitle';
import { useLoader } from '../../../../context/LoaderContext';
import { UserService } from '../../../../services/UserService';
import { ToasterService } from '../../../../services/ToasterService';
import { STATUS_SUCCESS } from '../../../../utils/constants';
import { ProductsService } from '../../../../services/ProductsService';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

export default function UseBillingInfo() {
  useDocumentTitle('Namasteji Manikchand - Billing Information');
  let parsedUserData: any = {};
  const navigate = useNavigate();
  const getUserLoginData = localStorage.getItem('userLoginData');
  const { setLoading } = useLoader();
  const addressDataArr = useRef<any>([]);
  const [shippingAddresses, setShippingAddresses] = useState<any>({});
  const [isOpenSelectAddressModal, setIsOpenSelectAddressModal] = useState<boolean>(false);
  const [selectedBillingShippingAddress, setSelectedBillingShippingAddress] = useState(null);
  const [addressFor, setAddressFor] = useState(null);
  const customerId = useRef('');
  const [productsList, setProductsList] = useState<any[]>([]);
  const [cartDataArr, setCartDataArr] = useState<any>({});
  const [placedOrderId, setPlacedOrderId] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<any>(new Date());
  const [error, setError] = useState('');

  useEffect(() => {
    if (getUserLoginData) {
      parsedUserData = JSON.parse(getUserLoginData);
      customerId.current = parsedUserData.customer_id;
      getAddressList(parsedUserData.customer_id);
      getProductsList(parsedUserData.customer_id);
    }
  }, []);

  async function getAddressList(customerId: string) {
    try {
      setLoading(true);
      const resp = await UserService.AddressList(customerId);
      setLoading(false);
      if (resp && resp.message && resp.message.addresses && resp.message.addresses.length > 0) {
        addressDataArr.current = resp.message.addresses;
        const shipping = addressDataArr.current.filter(
          (addr: any) => addr.is_shipping_address === 1
          // (addr: any) => (addr.is_primary_address === 1 && addr.is_shipping_address === 0)
        );
        setShippingAddresses(shipping[0]);
      }
    } catch (err) {
      setLoading(false);
      ToasterService.Error('Server Error!..');
    }
  }

  async function getProductsList(customerId: string) {
    try {
      const resp = await ProductsService.GetCustomerProductCartList(customerId);
      if (resp && resp.data) {
        if (resp && resp.data && resp.data.cart && Object.keys(resp.data.cart).length > 0) {
          setProductsList(resp.data?.cart?.items);
          setCartDataArr(resp.data?.cart);
        } else {
          ToasterService.Error('Cart Empty Please Add Item');
          navigate('/products');
        }
      } else if (resp && resp?.message && resp?.message.status_code === 404) {
        ToasterService.Error('Cart Empty Please Add Item');
        navigate('/products');
      } else {
        ToasterService.Error('Temporary issue, try again later.');
        navigate('/home');
      }
    } catch (error) {
      // console.log(error)
      ToasterService.Error('Server Error! Please wait....');
    }
  }

  function selectedDeliveryDate(date: any) {
    setError('');
    setSelectedDate(date);
  }

  const handlePlaceOrder = async () => {
    if (customerId && customerId.current) {
      if (!selectedDate) {
        setError('Please select a delivery date');
      } else {
        setError('');
        const formattedDate = format(selectedDate, 'yyyy-MM-dd');
        try {
          setLoading(true);
          const payload = {
            customer_id: customerId.current,
            delivery_date: formattedDate,
          };
          // console.log('Selected Delivery Date:', payload);
          const resp = await ProductsService.PlaceOrderProducts(payload);
          setLoading(false);
          if (resp && resp.status_code === 200) {
            const data = resp.data;
            if (data && data.order_id !== '' && data.order_id !== null) {
              setPlacedOrderId(data.order_id);
              localStorage.removeItem('quotation_items');
            } else {
              ToasterService.Error('Something Else try again sometime!');
            }
          } else {
            ToasterService.Error('Server Error!..');
            navigate('/products');
          }
        } catch (err) {
          setLoading(false);
          ToasterService.Error('Server Error!..');
        }
      }
    } else {
      ToasterService.Error('Please login Once Again');
      navigate('/login');
    }
  };

  const handleSelectAddress = async (name: any, e: any) => {
    if (e === true) {
      setSelectedBillingShippingAddress(name);
      let payload: any;
      if (addressFor === 'Billing') {
        payload = {
          address_id: name,
          is_primary_address: '1',
        };
      } else {
        payload = {
          address_id: name,
          is_shipping_address: '1',
        };
      }
      const resp = await UserService.UpdateAddress(payload);
      if (resp && resp.message && resp.message.status === STATUS_SUCCESS) {
        setIsOpenSelectAddressModal(false);
        getAddressList(customerId.current);
        ToasterService.Success('Address Changed Successfully!.');
      } else {
        ToasterService.Error('Something went wrong. Please try again later.');
      }
    }
  };

  function openSelectAddressModal(name: any, addressFor: any) {
    setAddressFor(addressFor);
    setSelectedBillingShippingAddress(name);
    setIsOpenSelectAddressModal(true);
  }

  const states = {
    addressDataArr,
    shippingAddresses,
    isOpenSelectAddressModal,
    selectedBillingShippingAddress,
    setIsOpenSelectAddressModal,
    productsList,
    cartDataArr,
    placedOrderId,
    selectedDate,
    error,
    selectedDeliveryDate,
    setSelectedDate,
  };

  return {
    states,
    handlePlaceOrder,
    handleSelectAddress,
    openSelectAddressModal,
    navigate,
  };
}
